import { DetailedLoadStatus } from "../../../../../../common/utils/async-status";
import { combineReducers } from "redux";
import { loadEnrichmentStatus, loadManifest } from "./actions";
import { initTightrope } from "./actions";

function servicesLoadStatus(state = DetailedLoadStatus.WAITING, action) {
  switch (action.type) {
    case initTightrope.pending.type:
      return DetailedLoadStatus.FETCHING;
    case initTightrope.fulfilled.type:
      return DetailedLoadStatus.OK;
    case initTightrope.rejected.type:
      return DetailedLoadStatus.ERROR;
    default:
      return state;
  }
}

function manifestLoadStatus(
  state = { status: DetailedLoadStatus.WAITING, errorCode: undefined },
  action
) {
  switch (action.type) {
    case loadManifest.pending.type:
      return { status: DetailedLoadStatus.FETCHING };
    case loadManifest.fulfilled.type:
      return { status: DetailedLoadStatus.OK };
    case loadManifest.rejected.type:
      return {
        status: DetailedLoadStatus.ERROR,
        errorCode: action.payload.errorCode,
      };
    default:
      return state;
  }
}

function enrichments(state = [], action) {
  switch (action.type) {
    case loadManifest.fulfilled.type:
      if (action.payload) {
        return action.payload.enrichments;
      } else {
        return [];
      }
    default:
      return state;
  }
}

function enrichmentStatusLoadStatus(
  state = DetailedLoadStatus.WAITING,
  action
) {
  switch (action.type) {
    case loadEnrichmentStatus.pending.type:
      return DetailedLoadStatus.FETCHING;
    case loadEnrichmentStatus.fulfilled.type:
      return DetailedLoadStatus.OK;
    case loadEnrichmentStatus.rejected.type:
      return DetailedLoadStatus.ERROR;
    default:
      return state;
  }
}

function enrichmentStatus(state = {}, action) {
  switch (action.type) {
    case loadEnrichmentStatus.fulfilled.type:
      return { ...state, ...action.payload.result.status };
    default:
      return state;
  }
}

export default combineReducers({
  servicesLoadStatus,
  manifestLoadStatus,
  enrichments,
  enrichmentStatusLoadStatus,
  enrichmentStatus,
});
